import React, { useState } from "react";
import { _getBaseUrl } from "../utils/helper";

const KeywordSearch = ({
  placeholder,
  searchValue,
  setSearchValue,
  onChange,
  onFocus,
  onBlur,
  onKeyUp,
  ...props
}) => {

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onChange && onChange(event);
  };

  return (
    <div className={`w-[91%] md:w-[96%] lg:w-[97%] ${props.class ?? ""}`}>
      <div className="container px-8 flex items-center w-full h-[60px] md:h-[75px] border rounded-md bg-white">
        <img
          src={`${_getBaseUrl("src/assets/icons/search-icon.svg", true)}`}
          alt="Search Icon"
          className="w-5 h-5 z-10"
        />
        <input
          type="text"
          id="search-input"
          className={`search placeholder-black block w-full px-8 stext-lg lg:text-2xl input-keyword`}
          placeholder={placeholder}
          value={searchValue}
          onChange={handleInputChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyUp={onKeyUp}
          aria-label={placeholder}
        />
        {searchValue && (
          <button
            onClick={() => {
              setSearchValue("");
            }}
            className="close z-10"
            aria-label="Zoekopdracht wissen"
          ></button>
        )}
      </div>
    </div>
  );
};

export default KeywordSearch;
